import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, InstagramIcon, MapPinIcon, InfoIcon } from 'lucide-react';
import { useFormEmbedScript } from '../hooks/useFormEmbedScript';
const FORM_ID = 'Vjrn3hbx1eKeZwcSeXGG';
export function Contact() {
  useFormEmbedScript();
  return <section id="contact" className="py-24 bg-offwhite-100" data-id="element-155" data-mp="2w7qlbw4b8v0y">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-156" data-mp="2w9bi7se3kq1z">
        <div className="grid lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] gap-12 lg:gap-16 items-start" data-id="element-157" data-mp="3sxzjve5ia0p8">
          {/* Intro / direct contact */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.4,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-158" data-mp="3oy8u9drptqma">
            <h2 className="text-4xl md:text-5xl font-bold text-charcoal-950 mb-5" data-id="element-159" data-mp="3jvkzohsloskv">
              Have a Question?
            </h2>
            <p className="text-xl text-charcoal-800 leading-relaxed mb-6" data-id="element-160" data-mp="3ouxnp5v7k5p1">
              Not sure if this is the right fit, or just want to understand your
              options? Send me a message and I'll get back to you personally.
            </p>

            <div className="flex gap-4 rounded-2xl border border-amber-500/40 bg-amber-500/10 p-5 mb-10" data-id="element-161" data-mp="3f2ru5rpb5g7q">
              <InfoIcon size={22} className="text-amber-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-162" data-mp="317fztlf2drrc" />
              <p className="text-charcoal-800 leading-relaxed" data-id="element-163" data-mp="2s5zqlgzzjvop">
                I'm happy to answer general questions about what you're dealing
                with and which care options might make sense.
              </p>
            </div>

            <h3 className="text-sm font-bold uppercase tracking-widest text-charcoal-500 mb-5" data-id="element-164" data-mp="uenb17mnnjeh">
              Reach me directly
            </h3>
            <ul className="space-y-5" data-id="element-165" data-mp="23cden8iyt4h8">
              <li className="flex items-center gap-4" data-id="element-166" data-mp="2397p5s6fc0kz">
                <span className="bg-white w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 border border-offwhite-200" data-id="element-167" data-mp="1ybg1598wgym2">
                  <MailIcon size={20} className="text-amber-500" aria-hidden="true" data-id="element-168" data-mp="1ud05yi2o0jxk" />
                </span>
                <a href="mailto:info@mcleanphysicaltherapy.com" className="text-charcoal-950 font-medium hover:text-amber-600 transition-colors break-all" data-id="element-169" data-mp="2m1a7d7yproxc">
                  info@mcleanphysicaltherapy.com
                </a>
              </li>
              <li className="flex items-center gap-4" data-id="element-170" data-mp="28aexbschb1s6">
                <span className="bg-white w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 border border-offwhite-200" data-id="element-171" data-mp="35qaxgzhbu4qa">
                  <InstagramIcon size={20} className="text-amber-500" aria-hidden="true" data-id="element-172" data-mp="30y1bfujc1ota" />
                </span>
                <a href="https://www.instagram.com/dylanmclean.dpt/" target="_blank" rel="noopener noreferrer" className="text-charcoal-950 font-medium hover:text-amber-600 transition-colors" data-id="element-173" data-mp="3da3p6ajeattw">
                  @dylanmclean.dpt
                </a>
              </li>
              <li className="flex items-center gap-4" data-id="element-174" data-mp="2s5d0zkj5op">
                <span className="bg-white w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 border border-offwhite-200" data-id="element-175" data-mp="17fhoo78ax6">
                  <MapPinIcon size={20} className="text-amber-500" aria-hidden="true" data-id="element-176" data-mp="9sliw7j9tuvl" />
                </span>
                <span className="text-charcoal-800" data-id="element-177" data-mp="itjfi4rdr045">
                  House of Gains Gym, Camarillo, CA
                  <span className="block text-sm text-charcoal-500" data-id="element-178" data-mp="56knnhxlnriz">
                    In-person visits by appointment only
                  </span>
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Embedded contact form */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.4,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white rounded-3xl border border-offwhite-200 shadow-lg p-4 md:p-6 overflow-hidden" data-id="element-179" data-mp="eyqcwjwgvuuh">
            <iframe src={`https://api.leadconnectorhq.com/widget/form/${FORM_ID}`} style={{
            width: '100%',
            height: 945,
            border: 'none',
            borderRadius: 8
          }} id={`inline-${FORM_ID}`} data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="CA - Contact Us Form" data-height="945" data-layout-iframe-id={`inline-${FORM_ID}`} data-form-id={FORM_ID} data-cookie-consent="true" data-cookie-consent-provider="auto" title="CA - Contact Us Form" data-id="element-180" data-mp="17ki5p6o50nqz" />
          </motion.div>
        </div>
      </div>
    </section>;
}